import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useMemo } from "react";
import { query, collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";

import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Last_week_cash_book_balance() {
    const [ledgerAccounts, setLedgerAccounts] = useState([]);
    const [chartLabels, setChartLabels] = useState([]);
    const [chartAmounts, setChartAmounts] = useState([]);
    const servicetablename = "accountingfinancedb";
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    // ---------------------------------------------------------
    // FIREBASE SNAPSHOT
    // ---------------------------------------------------------
    useEffect(() => {
        const companyId = Cookies.get("select_company_uid");
        if (!companyId) {
            Toastshow("Company not selected");
            return;
        }

        const ref = collection(db, servicetablename, companyId, "cash_books_accounting");
        const unsub = onSnapshot(ref, (snapshot) => {
            const rows = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
                _date: doc.data().date_time?.toDate
                    ? doc.data().date_time.toDate()
                    : new Date(doc.data().date_time),
            }));
            setLedgerAccounts(rows);
        });

        return () => unsub();
    }, []);

    // ---------------------------------------------------------
    // LAST 7 DAYS BALANCE
    // ---------------------------------------------------------
    useEffect(() => {
        if (!ledgerAccounts.length) return;

        const today = new Date();
        const labels = [];
        const amounts = [];

        for (let i = 6; i >= 0; i--) {
            const d = new Date();
            d.setDate(today.getDate() - i);

            labels.push(
                d.toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                })
            );

            const total = ledgerAccounts
                .filter((v) => v._date.toDateString() === d.toDateString())
                .reduce(
                    (sum, v) =>
                        sum + (Number(v.credit || 0) - Number(v.debit || 0)),
                    0
                );

            amounts.push(total);
        }

        setChartLabels(labels);
        setChartAmounts(amounts);
    }, [ledgerAccounts]);

    // ---------------------------------------------------------
    // PAN-ROUNDED BAR STYLE
    // ---------------------------------------------------------
    const chartData = useMemo(
        () => ({
            labels: chartLabels,
            datasets: [
                {
                    label: "Balance",
                    data: chartAmounts,
                    backgroundColor: (ctx) =>
                        ctx.raw >= 0 ? "#16a34a" : "#dc2626",
                    borderRadius: {
                        topLeft: 50,
                        topRight: 50,
                        bottomLeft: 50,
                        bottomRight: 50,
                    },
                    borderSkipped: false,
                    barThickness: 10,
                    categoryPercentage: 0.7,
                    barPercentage: 0.9,
                },
            ],
        }),
        [chartLabels, chartAmounts]
    );

const chartOptions = {
    maintainAspectRatio: false, // REQUIRED
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) =>
                    `Balance: ₹${Number(ctx.raw).toLocaleString("en-IN")}`,
            },
        },
    },
    scales: {
        y: {
            beginAtZero: true,
            grid: { display: false },
            ticks: { display: false },
        },
        x: {
            grid: { display: false },
        },
    },
};

    return (
        <div>
        <div style={{ height: "100px" }}>
                 <Bar data={chartData} options={chartOptions} />
            </div>
          
        </div>
    );
}
